import React from 'react';
import CatCatalog from '../components/CatCatalog';

const CatCatalogPage = () => {
  return (
    <main className="py-8">
      <CatCatalog />
    </main>
  );
};

export default CatCatalogPage; 